import type { AppSettingsI } from '@/types'

const appSettings: AppSettingsI = {
  name: 'Hubble',
  key: 'hubble',
  shortDescription:
    'Welcome to Hubble, your gateway to **GST Assurance & Analytics** tools. Access real-time **Insights**, **Reports**, **GenAI** tools, and **Compliance** resources. All from one unified hub.',
  description: `Hubble is a central hub that brings together all products from the GST Assurance and Analytics team. It provides a single access point for users to discover, explore, and navigate the team's tools, dashboards, and services - making insights, reports, and analytics easier to find and use.`,
  logo: '/images/logo.png',
}

export default appSettings
